"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMapPricingToGql = exports.createMapPricingToVod = void 0;
exports.createMapPricingToVod = function (pricingTypeMap) { return function (pricing) {
    return {
        type: pricingTypeMap.get(pricing.type),
        price: pricing.price,
        enabled: pricing.enabled,
        period: pricing.period,
    };
}; };
exports.createMapPricingToGql = function (pricingTypeMap) { return function (deal) {
    return {
        type: pricingTypeMap.get(deal.type),
        price: deal.price,
        enabled: deal.enabled,
        period: deal.period || -1,
        required: deal.required || false,
    };
}; };
//# sourceMappingURL=pricing.js.map